<template lang="pug">
    .products-template
        .products-template-title
            p(v-for="item in lenguageSelected.content1")   {{ item }}
            img(:src="image")
        .products-template-content
            .products-template-content-description
                p   {{ lenguageSelected.content2 }}
                .products-template-box
                    p   {{ lenguageSelected.content3 }}
                p   {{ lenguageSelected.content4 }}
</template>


<script>
import image from '@img/products/BannerSecundario_Tower&Rofftops.jpg'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            image: image,
            lenguage: 'EN',
            lenguageEN: {
                content1: ['ATP’s diversified tower and rooftop portfolios offer mobile network operators, broadcast, WISP and IoT providers a variety of solutions to fit their network needs. Our sites are strategically located in Colombia, Peru, Chile and Ecuador, across urban, suburban, and rural locations.'],
                content2: 'We build and acquire sites with an eye toward capacity for co-location, and carrier space expansion requirements.',
                content3: 'Our multi-tenant, long-term leasing model ensures carriers always have new site options, and the ability to connect their most important locations.',
                content4: 'To learn more about how our Tower & Rooftop solutions can address your needs, click the “Contact Us” button to your left.'
            },
            lenguageES: {
                content1: [
                    'Torres Celulares y Azoteas en Ubicaciones Urbanas, Suburbanas y Rurales',
                    'Nuestro portafolio diversificado de sitios, torres y azoteas le ofrece a los operadores de telefonía móvil, WISP y de IoT una variedad de soluciones para cubrir sus requerimientos de despliegue de red. Nuestros sitios están ubicados estratégicamente en Colombia, Perú, Chile y Ecuador, a través de ubicaciones urbanas, suburbanas y rurales.'
                ],
                content2: 'Construimos y adquirimos sitios tomando en cuenta la capacidad de co-ubicación y considerando futuras expansiones de espacio para la ubicación de más equipos en el sitio.',
                content3: 'Nuestro modelo de arrendamiento a largo plazo para múltiples inquilinos garantiza que los operadores siempre tengan nuevas opciones de espacio en el mismo sitio y la capacidad de contectar nuevos puntos de presencia a sus redes.',
                content4: 'Para obtener más información sobre cómo nuestras soluciones de Torres & Azoteas pueden satisfacer sus requerimientos y necesidades de cobertura y densificación, seleccione el boton de la izquierda para ir a la sección de contacto.'
            }
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/molecules/PmTowersAndRooftops.vue